import React, { useContext } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { IWithErrorHandlingProps, withErrorHandling } from '../withErrorHandling';
import { IUseApiProps } from '../useApi';
import { OrbUserContext } from '../OrbUserContext';
import ManageProjectsReportCls from './ManageProjectsReportCls';

export interface IManageProjectsReportProps extends IUseApiProps, IWithErrorHandlingProps {
}

const ManageProjectsReport = (props: IManageProjectsReportProps) => {
    const { userPermissions } = useContext(OrbUserContext);
    return (
        <ErrorBoundary>
            <ManageProjectsReportCls
                userPermissions={userPermissions}
                {...props}
            />
        </ErrorBoundary>
    );
};

export default withErrorHandling(ManageProjectsReport);